import { Icon } from '@nimbus-ds/components';
import { CheckIcon } from '@nimbus-ds/icons';
import { FulfillmentOrderLineItemForDocumentResponseDto } from '@tiendanube/common';
import useTranslationFulfillmentOrders from 'domains/FulfillmentOrders/useTranslationFulfillmentOrders';

interface ProductsDocumentPreviewProps {
  lineItems: FulfillmentOrderLineItemForDocumentResponseDto[];
  showTotalPrices?: boolean;
  showUnitPrices?: boolean;
  showSku?: boolean;
  showCheckboxPicking?: boolean;
  showProductImage?: boolean;
}

function ProductsDocumentPreview({
  lineItems,
  showTotalPrices = true,
  showUnitPrices = true,
  showSku = true,
  showCheckboxPicking = false,
  showProductImage = false,
}: Readonly<ProductsDocumentPreviewProps>) {
  const t = useTranslationFulfillmentOrders('documents.general.lineItems');

  return (
    <div className="products">
      <div className="product-row">
        <div className="product-row-info">
          {showCheckboxPicking && (
            <div className="checkbox-header">
              <Icon source={<CheckIcon size="small" />} />
            </div>
          )}
          <p className="bold product-name-title">{t('name')}</p>
          <p className="bold product-quantity">{t('quantityShort')}</p>
          {showUnitPrices && (
            <p className="bold product-unit-price">{t('unitPriceShort')}</p>
          )}
          {showTotalPrices && (
            <p className="bold product-total">{t('price')}</p>
          )}
        </div>
      </div>
      {lineItems.map(
        ({
          name,
          quantity,
          totalPrice,
          unitPrice,
          sku,
          properties,
          imageUrl,
        }) => (
          <div key={name} className="product-row">
            <div className="product-row-info">
              {showCheckboxPicking && (
                <div className="checkbox-container">
                  <div className="custom-checkbox" />
                </div>
              )}
              <div
                className={`product-name-wrapper ${
                  (showUnitPrices && !showTotalPrices) ||
                  (!showUnitPrices && showTotalPrices)
                    ? 'partial-price'
                    : ''
                } ${!showUnitPrices && !showTotalPrices ? 'no-price' : ''}`}
              >
                {showProductImage && (
                  <div className="product-image-container">
                    {!!imageUrl && (
                      <img
                        src={imageUrl}
                        alt={name}
                        className="product-thumbnail"
                      />
                    )}
                  </div>
                )}
                <div className="product-name">
                  <p className="bold">{name}</p>
                  {showSku && !!sku && (
                    <p className="product-sku">
                      {t('sku')} {sku}
                    </p>
                  )}
                </div>
              </div>
              <p className="product-quantity">{`${quantity}${
                showUnitPrices ? ' x' : ''
              }`}</p>
              {showUnitPrices && (
                <p className="product-unit-price">{unitPrice}</p>
              )}
              {showTotalPrices && (
                <p className="bold product-total">{totalPrice}</p>
              )}
            </div>
            {properties?.map(({ key, value }) => (
              <p key={sku + key} className="product-property">
                {key}: {value}
              </p>
            ))}
          </div>
        ),
      )}
    </div>
  );
}

export default ProductsDocumentPreview;
